module.exports = __webpack_public_path__ + "img/Membership.330ae8a6.svg";